/*
 * Reading an operator's hotkey list.
 *
 * The list comes from the server as {action, hotkey} pairs and is handed to
 * every screen that reacts to a key. The same list is now also shown - on the
 * buttons themselves and in the cheat sheet - so looking a combination up by
 * action, and writing one out for a human, belong in one place.
 *
 * A combination is stored exactly as the listener builds it: parts joined with
 * a plus, modifiers first ("Ctrl+Shift+H", "Alt+ArrowDown").
 */

/* The names the browser gives these keys are not what anyone calls them. */
const KEY_LABELS = {
    ArrowUp: '↑',
    ArrowDown: '↓',
    ArrowLeft: '←',
    ArrowRight: '→',
    Enter: '↵',
    Escape: 'Esc',
    Backspace: '⌫',
    Delete: 'Del',
    Meta: '⌘',
};

/** The combination set for an action, or '' when there is none - no feature, no list. */
export function hotkeyFor(hotkeys, action) {
    if (!hotkeys || hotkeys.length === 0) return '';

    const found = hotkeys.find(hk => hk.action === action);
    return found && found.hotkey ? found.hotkey : '';
}

/** The keys of a combination, each one ready to be drawn on its own. */
export function hotkeyKeys(hotkey) {
    if (!hotkey) return [];

    return hotkey.split('+').map(key => KEY_LABELS[key] || key);
}



// WEBPACK FOOTER //
// ./src/utils/hotkeys.js